import {StyleSheet} from 'react-native';

export const styles =  StyleSheet.create({
    page: {
        flex: 1,
        maxWidth: '100%',
        marginTop: 82,
        borderWidth: 1,
        borderColor: 'white',
        borderRadius: 24
    },

    scrollView: {

    },

    line: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
    },

    image: {
        height: 562.5,
        width: 570,
        resizeMode: 'cover',
        marginLeft: 16,
        borderWidth: 1,
        borderColor: 'white',
        borderRadius: 24
    }
});